
import { useState, useEffect } from 'react';
import './Auth.css';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    // Check if the user is already logged in (i.e., token exists in localStorage)
    const token = localStorage.getItem('jwtToken');
    if (token) {
      navigate('/'); // Redirect to home if already logged in
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const response = await fetch(`https://aeronauts-nsut.onrender.com/api/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });

        if (response.ok) {
            const data = await response.json();
            // Store token in localStorage with consistent naming
            localStorage.setItem('jwtToken', data.token); // Change 'token' to 'jwtToken'
            navigate('/'); // Redirect to dashboard or home page after successful login
        } else {
            const errorData = await response.json();
            setErrorMessage(errorData.message || "Login failed. Please try again.");
        }
    } catch (error) {
        console.error("Error during login:", error);
        setErrorMessage("An unexpected error occurred. Please try again later.");
    }
};


  // Handle Logout
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove token from localStorage
    navigate('/login'); // Redirect to login page
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="brand-text text-3xl mb-4">aeronauts</h1>
        <h1 className="auth-title">Log in</h1>

        {errorMessage && <p className="error-message">{errorMessage}</p>} {/* Display error message */}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email address"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
            />
          </div>
          <div className="form-group password-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="auth-input"
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type="submit" className="auth-button">
            Continue
          </button>

          <p className="auth-switch">
            Don't have an account? <a href="/signup">Sign up</a>
          </p>
          <p className="auth-switch">
            Forgot your password? <a href="/forgetpass">Reset password</a>
          </p>
        </form>

        <footer className="auth-footer">
          <div className="footer-links">
            <a href="/terms">Terms of Service</a>
            <span className="separator">|</span>
            <a href="/privacy">Privacy Policy</a>
          </div>
          <p className="copyright">
            © 2025 Aeronauts Inc. all rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default Login;
